// The Board Ask's words (EMC-WEB4), from Jonathan's approved walkthrough frames 20a–32 and his
// rulings of 2026-10-31: "An admin with access to the Board module needs to approve the board ask
// before it goes out" (23:00); "approve", never "sign off"; "fundraiser page", never "board members'
// pages". One home for every Board Ask surface: the campaign's composer, the approvers' page and the
// director's ask page.

export const BOARD_ASK_COPY = {
  create: 'Create Board Ask',
  createLede: (org: string) =>
    `Ask ${org}’s board to share the campaign, or to raise for it with pages of their own.`,
  message: 'Message',
  attachments: 'Attachments',
  addAttachments: 'Add attachments',
  remove: (title: string) => `Remove ${title}`,
  graphics: (n: number) => `${n} ${n === 1 ? 'graphic' : 'graphics'}`,
  fromCollateral: 'From Collateral',
  pdf: (size: string) => `PDF · ${size}`,
  whatDirectorsCanDo: 'What directors can do',
  shareLabel: 'Share the campaign with their own link',
  shareLine: 'Gifts that come through their link are counted as theirs.',
  pageLabel: 'Create their own fundraiser page under the campaign',
  pageLine: (goal: string | null) =>
    goal === null
      ? 'What their page raises counts toward the campaign.'
      : `What their page raises counts toward the ${goal} goal.`,
  pagesClosed: 'This campaign isn’t open for fundraiser pages yet. Upgrade it to a campaign first.',
  campaignNotLive:
    'This campaign isn’t live, so the board couldn’t act on it yet. Publish it first.',
  // DRAFT (EMC-BE17), for Jonathan's words: the card counts everyone the ask goes to, every seat on
  // the board whether or not the person is a director, so it says board members; and one is said as
  // one. Frame 20's "Goes to all 6 directors" called them all directors, and read "Goes to all 1
  // director" for one.
  goesTo: (n: number) =>
    n === 0
      ? 'Goes to the board'
      : n === 1
        ? 'Goes to 1 board member'
        : `Goes to all ${n} board members`,
  goesToLine: 'By email and on their to-do lists',
  noBoard: 'The board has no one on it yet. Add its members in Board first.',
  approvalNeeded:
    'An admin with access to the Board module needs to approve the board ask before it goes out.',
  submit: 'Submit for approval',
  submitted: 'Submitted for approval',
  submittedWhen: (when: string) =>
    `${when}. An admin with access to the Board module will approve it.`,
  approveAndSend: 'Approve and send',
  approvingSends: 'Approving sends it to the board now.',
  sendBack: (name: string | null) => (name ? `Send back to ${name.split(' ')[0]}` : 'Send back'),
  previewEmail: 'Preview the email',
  previewFrom: (name: string) => `From ${name}`,
  wentOut: (when: string) => `Went to the board on ${when}.`,
  sentBack: (name: string | null) =>
    name
      ? `${name} returned it to you. Change it, then submit it again.`
      : 'It came back to you. Change it, then submit it again.',
  save: 'Save draft',
  saved: 'Saved',
  reviewTitle: (campaign: string) => `${campaign}: Board Ask`,
  reviewLede: (drafter: string | null, day: string | null) =>
    drafter && day
      ? `${drafter} drafted this on ${day}. You can change anything before it goes.`
      : 'You can change anything before it goes.',
  saveFailed: 'We couldn’t save the Board Ask. Please try again.',
  sendFailed: 'We couldn’t send the Board Ask. Please try again.',
  unavailable: 'The Board Ask isn’t available here.',
  factsMissing:
    'We couldn’t reach the campaign’s latest details just now, so this shows what was saved.',
  // The picker (frame 20a).
  pickerTitle: 'Add attachments',
  pickerLede: (org: string) =>
    `From ${org ? `${org}’s` : 'your organization’s'} Collateral. Items marked out of date, or past their date, aren’t shown.`,
  pickerConfirm: 'Add attachments',
  // Who's taking part (frame 32).
  takingPart: 'Who’s taking part',
  takingPartLede: (goal: string | null) =>
    goal === null
      ? 'In alphabetical order.'
      : `In alphabetical order. Pages raise toward the ${goal} goal.`,
  director: 'Director',
  opened: 'Opened',
  shared: 'Shared the appeal',
  pageRaised: 'Their page raised',
  noPage: 'No page',
  notEmailed: (reason: string) =>
    reason === 'suppressed' ? 'Not emailed: on your do-not-email list' : 'The email didn’t go out',
  pageDraft: 'Making it',
  linkGifts: (n: number, amount: string) =>
    `Gifts through directors’ links so far: ${n}, raising ${amount}.`,
  // The Board Asks list.
  asksTitle: 'Board Asks',
  asksLede: 'What your board has been asked to help with.',
  asksEmpty: 'No Board Asks yet. One is created from a campaign in Fundraisers.',
  stateDraft: 'Draft',
  stateSubmitted: 'Waiting for approval',
} as const;
